import { Link, NavLink } from 'react-router-dom'

export const LegalNav = () => (
  <nav className="legal-v2__nav" aria-label="Legal pages">
    <NavLink to="/terms" className={({ isActive }) => (isActive ? 'is-active' : undefined)}>
      Terms
    </NavLink>
    <NavLink to="/privacy" className={({ isActive }) => (isActive ? 'is-active' : undefined)}>
      Privacy
    </NavLink>
  </nav>
)

export const LegalContact = ({ company = {} }) => {
  const { email, phone, address1, address2 } = company || {}

  return (
    <div className="legal-v2__contact">
      <p>
        Questions about these policies? Reach out through our contact form or use the details below
        when available.
      </p>
      <ul>
        {email ? (
          <li>
            Email: <a href={`mailto:${email}`}>{email}</a>
          </li>
        ) : (
          <li>
            Email: use the <Link to="/#contact">contact form</Link> on our site
          </li>
        )}
        {phone ? (
          <li>
            Phone: <a href={`tel:${phone}`}>{phone}</a>
          </li>
        ) : null}
        {address1 ? (
          <li>
            Address: {address1}
            {address2 ? `, ${address2}` : ''}
          </li>
        ) : null}
      </ul>
    </div>
  )
}
